export default {"src":"/_next/static/media/Frame.76b286f5.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};